import type { CSSProperties } from 'react';

export const rowContainer: CSSProperties = {
  display: 'flex',
  alignItems: 'center',
  gap: 8,
  padding: '10px 8px',
  minWidth: 0,
  width: '100%',
};

export const detailsWrap: CSSProperties = {
  flex: 1,
  minWidth: 0,
  overflow: 'hidden',
};

export const ellipsisInline: CSSProperties = {
  display: 'block',
  maxWidth: '100%',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
};

export const labelStyle: React.CSSProperties = {
  fontWeight: 600,
  marginBottom: 0,
  fontSize: '14px',
  lineHeight: '16px',
};
export const selectValueStyle: CSSProperties = {
  color: 'var(--text-primary)',
};
export const listWrap = (isSmallScreen: boolean): CSSProperties => ({
  maxHeight: isSmallScreen ? 'none' : 350,
  overflowY: isSmallScreen ? 'visible' : 'auto',
  overflowX: 'hidden',
});
